import React, { ReactNode } from "react";
import { Breadcrumb, Layout, Typography } from "antd";
import Loading from "components/loading";
const { Content } = Layout;
const { Title } = Typography;
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/cardContent.styled";

interface AuxProps {
  title: string;
  isLoading: boolean;
  children?: ReactNode;
}

const CardContent: React.FC<AuxProps> = (props) => {
  const { children, title, isLoading } = props;
  return (
    <Layout>
      <Content style={!isLoading ? S.Content : {}}>
        <Loading show={isLoading}>
          <>
            <Breadcrumb>
              <Breadcrumb.Item>
                <S.LayoutBreadcrumb>
                  <Title level={5} style={S.Title}>
                    {useTranslation({ id: title })}
                  </Title>
                </S.LayoutBreadcrumb>
              </Breadcrumb.Item>
            </Breadcrumb>
            <S.LayoutContent>{children}</S.LayoutContent>
          </>
        </Loading>
      </Content>
    </Layout>
  );
};

CardContent.defaultProps = {
  isLoading: false,
};

export default CardContent;
